// Generated by Melange

import * as Buhta_identapis__Buhta_ident_control_v1_ident_provider from "./buhta_ident_control_v1_ident_provider.js";
import * as Buhta_identapis__Buhta_ident_control_v1_verifiable_type from "./buhta_ident_control_v1_verifiable_type.js";
import * as Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_provider_state from "./buhta_ident_identification_v1alpha1_ident_provider_state.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";
import * as Stdlib from "melange/stdlib.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
  "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow.ml",
  174,
  6
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "IdentFlow"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "ActionIdScanInfo"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "ActionLivenessInfo"
                            ],
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "IdentFlowAction"
                      ]
                    ]
                  },
                  "V1alpha1"
                ]]
            },
            "Identification"
          ]]
      },
      "Ident"
    ]]
});

const Ident = Caml_module.init_mod([
  "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow.ml",
  310,
  8
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "IdentFlow"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "ActionIdScanInfo"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "ActionLivenessInfo"
                      ],
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "IdentFlowAction"
                ]
              ]
            },
            "V1alpha1"
          ]]
      },
      "Identification"
    ]]
});

const Identification = Caml_module.init_mod([
  "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow.ml",
  444,
  10
], {
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "IdentFlow"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "ActionIdScanInfo"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "ActionLivenessInfo"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "IdentFlowAction"
          ]
        ]
      },
      "V1alpha1"
    ]]
});

const V1alpha1 = Caml_module.init_mod([
  "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow.ml",
  576,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "IdentFlow"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "ActionIdScanInfo"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "ActionLivenessInfo"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "IdentFlowAction"
    ]
  ]
});

const IdentFlow = Caml_module.init_mod([
  "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow.ml",
  610,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const IdentFlowAction = Caml_module.init_mod([
  "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow.ml",
  748,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "ActionIdScanInfo"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "ActionLivenessInfo"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.ident.identification.v1alpha1.IdentFlow";
}

function make(idOpt, codeOpt, session_idOpt, stateOpt, current_action, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const code = codeOpt !== undefined ? codeOpt : "";
  const session_id = session_idOpt !== undefined ? session_idOpt : "";
  const state = stateOpt !== undefined ? stateOpt : "";
  return {
    id: id,
    code: code,
    session_id: session_id,
    state: state,
    current_action: current_action
  };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "code",
    "code"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_session_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    3,
    "session_id",
    "sessionId"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_state = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "state",
    "state"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_current_action = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    11,
    "current_action",
    "currentAction"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: IdentFlowAction.name,
    make: IdentFlowAction.make,
    from_proto: IdentFlowAction.from_proto,
    from_proto_exn: IdentFlowAction.from_proto_exn,
    to_proto: IdentFlowAction.to_proto,
    to_proto$p: IdentFlowAction.to_proto$p,
    merge: IdentFlowAction.merge,
    to_json: IdentFlowAction.to_json,
    from_json_exn: IdentFlowAction.from_json_exn,
    from_json: IdentFlowAction.from_json
  })
]));

function merge(t1, t2) {
  return {
    id: Curry._2(merge_id, t1.id, t2.id),
    code: Curry._2(merge_code, t1.code, t2.code),
    session_id: Curry._2(merge_session_id, t1.session_id, t2.session_id),
    state: Curry._2(merge_state, t1.state, t2.state),
    current_action: Curry._2(merge_current_action, t1.current_action, t2.current_action)
  };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "code",
      "code"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      3,
      "session_id",
      "sessionId"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "state",
      "state"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      11,
      "current_action",
      "currentAction"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: IdentFlowAction.name,
      make: IdentFlowAction.make,
      from_proto: IdentFlowAction.from_proto,
      from_proto_exn: IdentFlowAction.from_proto_exn,
      to_proto: IdentFlowAction.to_proto,
      to_proto$p: IdentFlowAction.to_proto$p,
      merge: IdentFlowAction.merge,
      to_json: IdentFlowAction.to_json,
      from_json_exn: IdentFlowAction.from_json_exn,
      from_json: IdentFlowAction.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil)))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p(writer, param) {
  Curry._6(serialize, writer, param.id, param.code, param.session_id, param.state, param.current_action);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(id, code, session_id, state, current_action) {
  return {
    id: id,
    code: code,
    session_id: session_id,
    state: state,
    current_action: current_action
  };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.ident.identification.v1alpha1.IdentFlow", spec(undefined))(options);
  return function (param) {
    return Curry._5(serialize, param.id, param.code, param.session_id, param.state, param.current_action);
  };
}

function constructor$1(id, code, session_id, state, current_action) {
  return {
    id: id,
    code: code,
    session_id: session_id,
    state: state,
    current_action: current_action
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.ident.identification.v1alpha1.IdentFlow", spec(undefined), constructor$1);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, IdentFlow, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

const ActionIdScanInfo = Caml_module.init_mod([
  "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow.ml",
  780,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ActionLivenessInfo = Caml_module.init_mod([
  "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow.ml",
  844,
  16
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$1(param) {
  return ".buhta.ident.identification.v1alpha1.IdentFlowAction.ActionIdScanInfo";
}

function make$1(provider_stateOpt, client_access_token, param) {
  const provider_state = provider_stateOpt !== undefined ? provider_stateOpt : Curry._1(Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_provider_state.Buhta.Ident.Identification.V1alpha1.VerifyIdCardScanState.from_int_exn, 0);
  return {
    provider_state: provider_state,
    client_access_token: client_access_token
  };
}

const merge_provider_state = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "provider_state",
    "providerState"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_provider_state.Buhta.Ident.Identification.V1alpha1.VerifyIdCardScanState),
  Curry._1(Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_provider_state.Buhta.Ident.Identification.V1alpha1.VerifyIdCardScanState.from_int_exn, 0)
]));

const merge_client_access_token = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "client_access_token",
    "clientAccessToken"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

function merge$1(t1, t2) {
  return {
    provider_state: Curry._2(merge_provider_state, t1.provider_state, t2.provider_state),
    client_access_token: Curry._2(merge_client_access_token, t1.client_access_token, t2.client_access_token)
  };
}

function spec$1(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "provider_state",
      "providerState"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_provider_state.Buhta.Ident.Identification.V1alpha1.VerifyIdCardScanState),
    Curry._1(Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_provider_state.Buhta.Ident.Identification.V1alpha1.VerifyIdCardScanState.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "client_access_token",
      "clientAccessToken"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
});

function to_proto$p$1(writer, param) {
  Curry._3(serialize$1, writer, param.provider_state, param.client_access_token);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(provider_state, client_access_token) {
  return {
    provider_state: provider_state,
    client_access_token: client_access_token
  };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
});

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$1, writer);
  });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.ident.identification.v1alpha1.IdentFlowAction.ActionIdScanInfo", spec$1(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.provider_state, param.client_access_token);
  };
}

function constructor$3(provider_state, client_access_token) {
  return {
    provider_state: provider_state,
    client_access_token: client_access_token
  };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.ident.identification.v1alpha1.IdentFlowAction.ActionIdScanInfo", spec$1(undefined), constructor$3);
});

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$1, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ActionIdScanInfo, {
  make: make$1,
  to_proto: to_proto$1,
  from_proto: from_proto$1,
  to_json: to_json$1,
  from_json: from_json$1,
  name: name$1,
  merge: merge$1,
  to_proto$p: to_proto$p$1,
  from_proto_exn: from_proto_exn$1,
  from_json_exn: from_json_exn$1
});

function name$2(param) {
  return ".buhta.ident.identification.v1alpha1.IdentFlowAction.ActionLivenessInfo";
}

function make$2(provider_stateOpt, client_access_token, param) {
  const provider_state = provider_stateOpt !== undefined ? provider_stateOpt : Curry._1(Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_provider_state.Buhta.Ident.Identification.V1alpha1.VerifyLivenessState.from_int_exn, 0);
  return {
    provider_state: provider_state,
    client_access_token: client_access_token
  };
}

const merge_provider_state$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "provider_state",
    "providerState"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_provider_state.Buhta.Ident.Identification.V1alpha1.VerifyLivenessState),
  Curry._1(Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_provider_state.Buhta.Ident.Identification.V1alpha1.VerifyLivenessState.from_int_exn, 0)
]));

const merge_client_access_token$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "client_access_token",
    "clientAccessToken"
  ],
  Ocaml_protoc_plugin__Spec.string
]));

function merge$2(t1, t2) {
  return {
    provider_state: Curry._2(merge_provider_state$1, t1.provider_state, t2.provider_state),
    client_access_token: Curry._2(merge_client_access_token$1, t1.client_access_token, t2.client_access_token)
  };
}

function spec$2(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "provider_state",
      "providerState"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_provider_state.Buhta.Ident.Identification.V1alpha1.VerifyLivenessState),
    Curry._1(Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_provider_state.Buhta.Ident.Identification.V1alpha1.VerifyLivenessState.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "client_access_token",
      "clientAccessToken"
    ],
    Ocaml_protoc_plugin__Spec.string
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
});

function to_proto$p$2(writer, param) {
  Curry._3(serialize$2, writer, param.provider_state, param.client_access_token);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(provider_state, client_access_token) {
  return {
    provider_state: provider_state,
    client_access_token: client_access_token
  };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
});

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$2, writer);
  });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.ident.identification.v1alpha1.IdentFlowAction.ActionLivenessInfo", spec$2(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.provider_state, param.client_access_token);
  };
}

function constructor$5(provider_state, client_access_token) {
  return {
    provider_state: provider_state,
    client_access_token: client_access_token
  };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.ident.identification.v1alpha1.IdentFlowAction.ActionLivenessInfo", spec$2(undefined), constructor$5);
});

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$2, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ActionLivenessInfo, {
  make: make$2,
  to_proto: to_proto$2,
  from_proto: from_proto$2,
  to_json: to_json$2,
  from_json: from_json$2,
  name: name$2,
  merge: merge$2,
  to_proto$p: to_proto$p$2,
  from_proto_exn: from_proto_exn$2,
  from_json_exn: from_json_exn$2
});

function name$3(param) {
  return ".buhta.ident.identification.v1alpha1.IdentFlowAction";
}

function make$3(idOpt, type$pOpt, stateOpt, providerOpt, actionOpt, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const type$p = type$pOpt !== undefined ? type$pOpt : Curry._1(Buhta_identapis__Buhta_ident_control_v1_verifiable_type.Buhta.Ident.Control.V1.VerifiableType.from_int_exn, 0);
  const state = stateOpt !== undefined ? stateOpt : "";
  const provider = providerOpt !== undefined ? providerOpt : Curry._1(Buhta_identapis__Buhta_ident_control_v1_ident_provider.Buhta.Ident.Control.V1.IdentProvider.from_int_exn, 0);
  const action = actionOpt !== undefined ? actionOpt : "not_set";
  return {
    id: id,
    "type'": type$p,
    state: state,
    provider: provider,
    action: action
  };
}

const merge_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_type$p = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "type",
    "type"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_identapis__Buhta_ident_control_v1_verifiable_type.Buhta.Ident.Control.V1.VerifiableType),
  Curry._1(Buhta_identapis__Buhta_ident_control_v1_verifiable_type.Buhta.Ident.Control.V1.VerifiableType.from_int_exn, 0)
]));

const merge_state$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    3,
    "state",
    "state"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const merge_provider = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    4,
    "provider",
    "provider"
  ],
  Ocaml_protoc_plugin__Spec.$$enum(Buhta_identapis__Buhta_ident_control_v1_ident_provider.Buhta.Ident.Control.V1.IdentProvider),
  Curry._1(Buhta_identapis__Buhta_ident_control_v1_ident_provider.Buhta.Ident.Control.V1.IdentProvider.from_int_exn, 0)
]));

const merge_oneof_action__Id_scan_info = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: ActionIdScanInfo.name,
    make: ActionIdScanInfo.make,
    from_proto: ActionIdScanInfo.from_proto,
    from_proto_exn: ActionIdScanInfo.from_proto_exn,
    to_proto: ActionIdScanInfo.to_proto,
    to_proto$p: ActionIdScanInfo.to_proto$p,
    merge: ActionIdScanInfo.merge,
    to_json: ActionIdScanInfo.to_json,
    from_json_exn: ActionIdScanInfo.from_json_exn,
    from_json: ActionIdScanInfo.from_json
  })
]));

const merge_oneof_action__Liveness_info = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
  [
    0,
    "",
    ""
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: ActionLivenessInfo.name,
    make: ActionLivenessInfo.make,
    from_proto: ActionLivenessInfo.from_proto,
    from_proto_exn: ActionLivenessInfo.from_proto_exn,
    to_proto: ActionLivenessInfo.to_proto,
    to_proto$p: ActionLivenessInfo.to_proto$p,
    merge: ActionLivenessInfo.merge,
    to_json: ActionLivenessInfo.to_json,
    from_json_exn: ActionLivenessInfo.from_json_exn,
    from_json: ActionLivenessInfo.from_json
  })
]));

function merge$3(t1, t2) {
  const match = t1.action;
  const match$1 = t2.action;
  let tmp;
  let exit = 0;
  if (typeof match === "string") {
    exit = 1;
  } else {
    const variant = match.NAME;
    if (variant === "Liveness_info") {
      if (typeof match$1 === "string" || match$1.NAME !== "Liveness_info") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Liveness_info",
          VAL: Curry._2(merge_oneof_action__Liveness_info, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Id_scan_info" && !(typeof match$1 === "string" || match$1.NAME !== "Id_scan_info")) {
      tmp = {
        NAME: "Id_scan_info",
        VAL: Curry._2(merge_oneof_action__Id_scan_info, match.VAL, match$1.VAL)
      };
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    tmp = match$1 === "not_set" ? match : match$1;
  }
  return {
    id: Curry._2(merge_id$1, t1.id, t2.id),
    "type'": Curry._2(merge_type$p, t1["type'"], t2["type'"]),
    state: Curry._2(merge_state$1, t1.state, t2.state),
    provider: Curry._2(merge_provider, t1.provider, t2.provider),
    action: tmp
  };
}

function spec$3(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "type",
      "type"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_identapis__Buhta_ident_control_v1_verifiable_type.Buhta.Ident.Control.V1.VerifiableType),
    Curry._1(Buhta_identapis__Buhta_ident_control_v1_verifiable_type.Buhta.Ident.Control.V1.VerifiableType.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      3,
      "state",
      "state"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      4,
      "provider",
      "provider"
    ],
    Ocaml_protoc_plugin__Spec.$$enum(Buhta_identapis__Buhta_ident_control_v1_ident_provider.Buhta.Ident.Control.V1.IdentProvider),
    Curry._1(Buhta_identapis__Buhta_ident_control_v1_ident_provider.Buhta.Ident.Control.V1.IdentProvider.from_int_exn, 0)
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.oneof([
    {
      hd: Ocaml_protoc_plugin__Spec.oneof_elem([
        [
          5,
          "id_scan_info",
          "idScanInfo"
        ],
        Ocaml_protoc_plugin__Spec.message({
          name: ActionIdScanInfo.name,
          make: ActionIdScanInfo.make,
          from_proto: ActionIdScanInfo.from_proto,
          from_proto_exn: ActionIdScanInfo.from_proto_exn,
          to_proto: ActionIdScanInfo.to_proto,
          to_proto$p: ActionIdScanInfo.to_proto$p,
          merge: ActionIdScanInfo.merge,
          to_json: ActionIdScanInfo.to_json,
          from_json_exn: ActionIdScanInfo.from_json_exn,
          from_json: ActionIdScanInfo.from_json
        }),
        [
          (function (v) {
            return {
              NAME: "Id_scan_info",
              VAL: v
            };
          }),
          (function (param) {
            if (typeof param === "string") {
              throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                    MEL_EXN_ID: Stdlib.Invalid_argument,
                    _1: "Cannot destruct given oneof"
                  });
            }
            if (param.NAME === "Id_scan_info") {
              return param.VAL;
            }
            throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                  MEL_EXN_ID: Stdlib.Invalid_argument,
                  _1: "Cannot destruct given oneof"
                });
          })
        ]
      ]),
      tl: {
        hd: Ocaml_protoc_plugin__Spec.oneof_elem([
          [
            6,
            "liveness_info",
            "livenessInfo"
          ],
          Ocaml_protoc_plugin__Spec.message({
            name: ActionLivenessInfo.name,
            make: ActionLivenessInfo.make,
            from_proto: ActionLivenessInfo.from_proto,
            from_proto_exn: ActionLivenessInfo.from_proto_exn,
            to_proto: ActionLivenessInfo.to_proto,
            to_proto$p: ActionLivenessInfo.to_proto$p,
            merge: ActionLivenessInfo.merge,
            to_json: ActionLivenessInfo.to_json,
            from_json_exn: ActionLivenessInfo.from_json_exn,
            from_json: ActionLivenessInfo.from_json
          }),
          [
            (function (v) {
              return {
                NAME: "Liveness_info",
                VAL: v
              };
            }),
            (function (param) {
              if (typeof param === "string") {
                throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                      MEL_EXN_ID: Stdlib.Invalid_argument,
                      _1: "Cannot destruct given oneof"
                    });
              }
              if (param.NAME === "Liveness_info") {
                return param.VAL;
              }
              throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                    MEL_EXN_ID: Stdlib.Invalid_argument,
                    _1: "Cannot destruct given oneof"
                  });
            })
          ]
        ]),
        tl: /* [] */ 0
      }
    },
    (function (param) {
      if (typeof param === "string") {
        return Stdlib.failwith("Impossible case");
      } else if (param.NAME === "Id_scan_info") {
        return 0;
      } else {
        return 1;
      }
    })
  ]), Ocaml_protoc_plugin__Spec.nil)))));
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
});

function to_proto$p$3(writer, param) {
  Curry._6(serialize$3, writer, param.id, param["type'"], param.state, param.provider, param.action);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(id, type$p, state, provider, action) {
  return {
    id: id,
    "type'": type$p,
    state: state,
    provider: provider,
    action: action
  };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
});

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$3, writer);
  });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.ident.identification.v1alpha1.IdentFlowAction", spec$3(undefined))(options);
  return function (param) {
    return Curry._5(serialize, param.id, param["type'"], param.state, param.provider, param.action);
  };
}

function constructor$7(id, type$p, state, provider, action) {
  return {
    id: id,
    "type'": type$p,
    state: state,
    provider: provider,
    action: action
  };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.ident.identification.v1alpha1.IdentFlowAction", spec$3(undefined), constructor$7);
});

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$3, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "ActionIdScanInfo"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "ActionLivenessInfo"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, IdentFlowAction, {
  ActionIdScanInfo: ActionIdScanInfo,
  ActionLivenessInfo: ActionLivenessInfo,
  make: make$3,
  to_proto: to_proto$3,
  from_proto: from_proto$3,
  to_json: to_json$3,
  from_json: from_json$3,
  name: name$3,
  merge: merge$3,
  to_proto$p: to_proto$p$3,
  from_proto_exn: from_proto_exn$3,
  from_json_exn: from_json_exn$3
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "IdentFlow"
    ],
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "ActionIdScanInfo"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "ActionLivenessInfo"
          ],
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "IdentFlowAction"
    ]
  ]
}, V1alpha1, {
  IdentFlow: IdentFlow,
  IdentFlowAction: IdentFlowAction
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "IdentFlow"
          ],
          [
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "ActionIdScanInfo"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "ActionLivenessInfo"
                ],
                [
                  /* Function */ 0,
                  "make"
                ],
                [
                  /* Function */ 0,
                  "to_proto"
                ],
                [
                  /* Function */ 0,
                  "from_proto"
                ],
                [
                  /* Function */ 0,
                  "to_json"
                ],
                [
                  /* Function */ 0,
                  "from_json"
                ],
                [
                  /* Function */ 0,
                  "name"
                ],
                [
                  /* Function */ 0,
                  "merge"
                ],
                [
                  /* Function */ 0,
                  "to_proto$p"
                ],
                [
                  /* Function */ 0,
                  "from_proto_exn"
                ],
                [
                  /* Function */ 0,
                  "from_json_exn"
                ]
              ]
            },
            "IdentFlowAction"
          ]
        ]
      },
      "V1alpha1"
    ]]
}, Identification, {
  V1alpha1: V1alpha1
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "IdentFlow"
                ],
                [
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "ActionIdScanInfo"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "ActionLivenessInfo"
                      ],
                      [
                        /* Function */ 0,
                        "make"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto"
                      ],
                      [
                        /* Function */ 0,
                        "to_json"
                      ],
                      [
                        /* Function */ 0,
                        "from_json"
                      ],
                      [
                        /* Function */ 0,
                        "name"
                      ],
                      [
                        /* Function */ 0,
                        "merge"
                      ],
                      [
                        /* Function */ 0,
                        "to_proto$p"
                      ],
                      [
                        /* Function */ 0,
                        "from_proto_exn"
                      ],
                      [
                        /* Function */ 0,
                        "from_json_exn"
                      ]
                    ]
                  },
                  "IdentFlowAction"
                ]
              ]
            },
            "V1alpha1"
          ]]
      },
      "Identification"
    ]]
}, Ident, {
  Identification: Identification
});

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [[
      {
        TAG: /* Module */ 0,
        _0: [[
            {
              TAG: /* Module */ 0,
              _0: [[
                  {
                    TAG: /* Module */ 0,
                    _0: [
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "IdentFlow"
                      ],
                      [
                        {
                          TAG: /* Module */ 0,
                          _0: [
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "ActionIdScanInfo"
                            ],
                            [
                              {
                                TAG: /* Module */ 0,
                                _0: [
                                  [
                                    /* Function */ 0,
                                    "make"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "name"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "merge"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "to_proto$p"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_proto_exn"
                                  ],
                                  [
                                    /* Function */ 0,
                                    "from_json_exn"
                                  ]
                                ]
                              },
                              "ActionLivenessInfo"
                            ],
                            [
                              /* Function */ 0,
                              "make"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto"
                            ],
                            [
                              /* Function */ 0,
                              "to_json"
                            ],
                            [
                              /* Function */ 0,
                              "from_json"
                            ],
                            [
                              /* Function */ 0,
                              "name"
                            ],
                            [
                              /* Function */ 0,
                              "merge"
                            ],
                            [
                              /* Function */ 0,
                              "to_proto$p"
                            ],
                            [
                              /* Function */ 0,
                              "from_proto_exn"
                            ],
                            [
                              /* Function */ 0,
                              "from_json_exn"
                            ]
                          ]
                        },
                        "IdentFlowAction"
                      ]
                    ]
                  },
                  "V1alpha1"
                ]]
            },
            "Identification"
          ]]
      },
      "Ident"
    ]]
}, Buhta, {
  Ident: Ident
});

export {
  Imported$pmodules,
  Buhta,
}
/* Buhta Not a pure module */
